import Image from 'next/image';
import { useTranslations } from 'next-intl';

import NaosText from '@/fo/icons/base/logos/naos-text.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import womenImage from '../../assets/women.webp';

import { styles } from './HeroBanner.styles';

interface HeroBannerProps {
  onClick: () => void;
}

export function HeroBanner({ onClick }: HeroBannerProps) {
  const t = useTranslations();

  const slots = styles();

  const title = t('article.page.loyalty.title');
  const splitTitle = title.split(' ');

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.mobileWrapper()}>
          <div className={slots.imageContainer()}>
            <Image
              className={slots.image()}
              src={womenImage}
              alt={title}
              fill
            />
          </div>
        </div>
        <div className={slots.content()}>
          <h1 className={slots.title()}>{title}</h1>
          <NaosText className={slots.logo()} />

          <div className={slots.firstTitle()}>{splitTitle[0]}</div>
          <div className={slots.secondTitle()}>{splitTitle[1]}</div>

          <div className={slots.description()}>
            {t('article.page.loyalty.description')}
          </div>

          <UiKitButtonBase
            onClick={onClick}
            className={slots.button()}
            color="primary"
          >
            {t('article.page.loyalty.button')}
          </UiKitButtonBase>
        </div>
      </div>
    </div>
  );
}
